// Copyright (c) StrangeBee 2023

import { Tooltip, TooltipProps } from 'antd';
import React, { ReactElement } from 'react';

import './THTooltip.scss';

type THTooltipProps = TooltipProps;

export const THTooltip = ({ children, ...props }: THTooltipProps): ReactElement => (
    <Tooltip overlayClassName="th-tooltip" {...props}>
        {children}
    </Tooltip>
);
